import * as React from 'react';

function SvgBarcodeScanOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="BarcodeScanOutlined_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <defs>
        <style />
      </defs>
      <path d="M822.588 970.667H800a24 24 0 010-48h31.059A112.941 112.941 0 00944 809.725v-31.058a24 24 0 1148 0v22.588a169.412 169.412 0 01-169.412 169.412zm25.412-192h-48v-576h48v576zm120-552a24 24 0 01-24-24v-31.06a112.941 112.941 0 00-112.941-112.94H800a24 24 0 010-48h22.588A169.412 169.412 0 01992 180.078v22.589a24 24 0 01-24 24zm-264 504h48v48h-48v-48zm24-528h24v480h-24v-480zm-96 528h48v48h-48v-48zm24-528h24v480h-24v-480zm-96 528h48v48h-48v-48zm0-528h48v480h-48v-480zm-72 528h48v48h-48v-48zm-72-528h96v480h-96v-480zm-72 528h48v48h-48v-48zm0-528h24v480h-24v-480zm-72 528h48v48h-48v-48zm0-528h24v480h-24v-480zm-48 768h-22.588A169.412 169.412 0 0132 801.255v-22.588a24 24 0 1148 0v31.058a112.941 112.941 0 00112.941 112.942H224a24 24 0 010 48zm0-192h-48v-576h48v576zm0-720h-31.059A112.941 112.941 0 0080 171.607v31.06a24 24 0 01-48 0v-22.589A169.412 169.412 0 01201.412 10.667H224a24 24 0 110 48zm240 720h-48v-48h48v48z" />
    </svg>
  );
}

export default SvgBarcodeScanOutlined;
